import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Alert, Paper, Box, Typography, Grid, Link, } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useAuth } from "@sal/authentication.react";
import { usePortalFramework } from "../../PortalFramework";
import { useNavigate, useParams } from "react-router-dom";
const Container = styled("div")(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        width: 300,
    },
    [theme.breakpoints.up("sm")]: {
        width: 350,
    },
    [theme.breakpoints.up("lg")]: {
        width: 400,
    },
}));
export const LoginWithToken = () => {
    const portalFramework = usePortalFramework();
    const auth = useAuth();
    const navigate = useNavigate();
    const theme = useTheme();
    const { token, returnUrl } = useParams();
    // #region PROPERTIES
    const [getMessage, setMessage] = useState("");
    //#endregion
    // #region EVENT HANDLERS
    useEffect(() => {
        if (token === undefined) {
            navigate("/Login");
        }
        auth.loginWithToken(token, login_callback, null, returnUrl);
    }, []);
    const login_callback = (response) => {
        if (response.success) {
            console.debug("Logged in, now redirecting to home page");
            if (returnUrl !== undefined) {
                console.debug("ReturnUrl: " + returnUrl);
                navigate(returnUrl);
            }
            else {
                navigate("/");
            }
        }
        else {
            setMessage(response.message);
        }
    };
    //#endregion
    return (_jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", style: { minHeight: "100vh" }, children: [_jsx(Box, { sx: theme.portalFramework.pages.login.backgroundContainer.sx }), _jsx(Container, { children: _jsx(Paper, { elevation: 3, sx: { padding: theme.spacing(2) }, children: _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 4, children: [_jsx(Grid, { item: true, children: _jsx(Box, { sx: {
                                        paddingTop: "1rem",
                                    }, children: _jsx("img", { style: { maxWidth: "100%", maxHeight: "20rem" }, src: portalFramework.settings.logoUrl, alt: "Logo" }) }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h4", align: "center", children: portalFramework.settings.loginTitle }) }), _jsx(Grid, { item: true, xs: 12, children: getMessage ? (_jsx(Alert, { severity: "error", children: getMessage })) : null }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Link, { variant: "body1", href: "#/Login", children: "Return to login page" }) })] }) }) })] }));
};
